import React from 'react'
import {
  Icon,
  Text,
  Box,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  Button,
  LinkBox,
  LinkOverlay,
  IconButton,
  Tooltip,
  HStack,
} from '@chakra-ui/react'
import { FaCheck } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { IoTrashOutline } from 'react-icons/io5'
import { noop } from 'lodash'
import { useTranslation } from 'react-i18next'

import { CustomAddressItemProps } from './types'
import {
  getContainerStyles,
  actionStackStyles,
  checkIconStyles
} from './styles'

export const CustomAddressItem = (props: CustomAddressItemProps) => {
  const {
    name,
    address,
    taxId,
    onClick = noop,
    onDelete = noop,
    onEdit = noop,
    isSelected = false,
  } = props
  const { t } = useTranslation(['payment'])

  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure()

  return (
    <React.Fragment>
      <LinkBox {...getContainerStyles(isSelected)}>
        <LinkOverlay
          as="div"
          cursor="pointer"
          userSelect="none"
          layerStyle="actionable"
          onClick={onClick}
        >
          <HStack>
            <Text as="h3" fontWeight="bold">
              {name}
            </Text>
            {isSelected && <CheckIcon />}
          </HStack>
          <Box>
            <Text>{t('companyTaxInvoiceForm.taxId')}{taxId}</Text>
            <Text>{address}</Text>
          </Box>
        </LinkOverlay>

        <HStack {...actionStackStyles}>
          <Tooltip label="แก้ไข" hasArrow>
            <IconButton
              icon={<Icon as={FiEdit} />}
              variant="ghost"
              data-testid="address-edit"
              aria-label="edit address"
              onClick={(e) => {
                e.stopPropagation()
                onEdit()
              }}
              fontSize="md"
              size="sm"
            />
          </Tooltip>
          <Tooltip label="ลบ" hasArrow>
            <IconButton
              colorScheme="red"
              color="#c63636"
              icon={<Icon as={IoTrashOutline} />}
              variant="ghost"
              data-testid="address-delete"
              aria-label="delete address"
              onClick={(e) => {
                e.stopPropagation()
                onOpenDelete()
              }}
              fontSize="md"
              size="sm"
            />
          </Tooltip>
        </HStack>
      </LinkBox>

      <Modal
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        blockScrollOnMount={false}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('companyTaxInvoiceForm.deleteConfirmation')}</ModalHeader>
          <ModalCloseButton />

          <ModalFooter>
            <Button onClick={onCloseDelete} mr={3} variant="outline">
              {t('companyTaxInvoiceForm.cancel')}
            </Button>
            <Button
              colorScheme="red"
              onClick={() => {
                onDelete()
                onCloseDelete()
              }}
              id="confirm-delete-address-button"
            >
              {t('companyTaxInvoiceForm.confirm')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}

const CheckIcon = () => {
  return (
    <Box {...checkIconStyles} id="address-check-icon">
      <Icon as={FaCheck} color="white" boxSize="10px" />
    </Box>
  )
}
